// Selectors
/**
 * @function getProductsInfoStore
 * @param {Object} state The redux state
 * @return {Object} the productsInfo store
 */
export const getProductsInfoStore = state => state.productsInfo;

/**
 * @function getProductsInfoList
 * @param {Object} state The redux state
 * @return {Object} the productsInfo list
 */
export const getProductsInfoList = state => getProductsInfoStore(state).products;

/**
 * @function getProductInfo
 * @param {Object} state The redux state
 * @param {String} productCode the product code to search for
 * @return {Object|null} the requested product info || null
 */
export const getProductInfo = (state, productCode) => {
  const [style, color] = productCode.split('-');

  if (style && color) {
    return getProductsInfoList(state)?.[style]?.[color] || null;
  }
  return null;
};

/**
 * @function getProductInfoBeingFetched
 * @param {Object} state The redux state
 * @return {Array} the array of findAndDeleteProductCodes being fetched
 */
export const getProductInfoBeingFetched = state => getProductsInfoStore(state).productCodesBeingFetched;

/**
 * @function getIsFetchingProductInfo
 * @param {Object} state The redux state
 * @param {String} productCode the product code to search for
 * @return {Boolean} if the supplied productCode is being fetched
 */
export const getIsFetchingProductInfo = (state, productCode) =>
  getProductInfoBeingFetched(state).includes(productCode.split('-')[0]);

// export default
export default {
  getProductsInfoStore,
  getProductsInfoList,
  getProductInfoBeingFetched,
  getIsFetchingProductInfo,
  getProductInfo
};
